export async function hashPassword(password: string): Promise<string> {
  const subtle = getSubtleCrypto();
  if (!subtle) {
    return simpleFallbackHash(password);
  }

  const encoder = new TextEncoder();
  const data = encoder.encode(password);
  const hashBuffer = await subtle.digest('SHA-256', data);
  const hashArray = Array.from(new Uint8Array(hashBuffer));

  return hashArray.map((byte) => byte.toString(16).padStart(2, '0')).join('');
}

export async function verifyPassword(password: string, hash: string): Promise<boolean> {
  const candidate = await hashPassword(password);
  return candidate === hash;
}

function getSubtleCrypto(): SubtleCrypto | null {
  if (typeof crypto !== 'undefined' && crypto?.subtle) {
    return crypto.subtle;
  }

  if (typeof window !== 'undefined' && window.crypto?.subtle) {
    return window.crypto.subtle;
  }

  if (typeof globalThis !== 'undefined') {
    const globalCrypto = (globalThis as typeof globalThis & { crypto?: Crypto }).crypto;
    if (globalCrypto?.subtle) {
      return globalCrypto.subtle;
    }
  }

  return null;
}

function simpleFallbackHash(password: string): string {
  let hash = 0;

  for (let i = 0; i < password.length; i++) {
    const char = password.charCodeAt(i);
    hash = (hash << 5) - hash + char;
    hash |= 0;
  }

  return `fallback_${Math.abs(hash)}`;
}

